export function conversionUnit(num) {
    if (typeof num !== "number") return 0
    return (num / 10000).toFixed(2)
}



// WEBPACK FOOTER //
// ./src/utils/utils.js